import template from './teamRequestCoincidences.html';
import controller from './teamRequestCoincidences.controller';
import './teamRequestCoincidences.scss';

let teamRequestCoincidencesComponent = {
  restrict: 'E',
  bindings: {
    request: '<',
    isDisabled: '<',
    isDisabledByDelegation: '<',
    showModalWarningDelegation: '&'
  },
  template,
  controller
};

export default teamRequestCoincidencesComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCoincidences/teamRequestCoincidences.component.js